import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body py-5" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "required fw-bold fs-6 mt-5" }, " Sumber Berita ")
], -1)
const _hoisted_5 = { class: "col-10 fv-row" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = ["for"]
const _hoisted_8 = { class: "svg-icon svg-icon-3x me-5" }
const _hoisted_9 = { class: "d-block fw-bold text-start" }
const _hoisted_10 = { class: "text-dark fw-bolder d-block fs-4" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "d-flex gap-2 align-center justify-content-end py-5" }
const _hoisted_15 = { class: "card-header border-0 cursor-pointer" }
const _hoisted_16 = ["data-bs-target", "aria-controls"]
const _hoisted_17 = { class: "fw-bolder" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["id"]
const _hoisted_20 = { class: "card-body mt-0" }
const _hoisted_21 = { class: "d-flex gap-2 justify-content-end" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Simpan Semua Data ", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Menyimpan Data... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_MediaTVFormInput = _resolveComponent("MediaTVFormInput")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.source, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.value,
                  class: "col-4"
                }, [
                  _createVNode(_component_Field, {
                    modelValue: _ctx.source,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.source) = $event)),
                    type: "radio",
                    class: "btn-check",
                    name: "source",
                    value: item.value,
                    id: item.value,
                    disabled: item.value != 'media_tv'
                  }, null, 8, ["modelValue", "value", "id", "disabled"]),
                  _createElementVNode("label", {
                    class: "btn btn-outline btn-outline-dashed btn-outline-default p-2 d-flex align-items-center h-100",
                    for: item.value
                  }, [
                    _createElementVNode("span", _hoisted_8, [
                      (item.value === 'media_cetak')
                        ? (_openBlock(), _createBlock(_component_inline_svg, {
                            key: 0,
                            src: "/media/icons/duotune/communication/com005.svg"
                          }))
                        : (item.value === 'media_tv')
                          ? (_openBlock(), _createBlock(_component_inline_svg, {
                              key: 1,
                              src: "/media/icons/duotune/electronics/elc004.svg"
                            }))
                          : (_openBlock(), _createBlock(_component_inline_svg, {
                              key: 2,
                              src: "/media/icons/duotune/layouts/lay009.svg"
                            }))
                    ]),
                    _createElementVNode("span", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(item.title), 1),
                      (item.value != 'media_tv')
                        ? (_openBlock(), _createElementBlock("small", _hoisted_11, " Sumber Belum Didukung "))
                        : _createCommentVNode("", true)
                    ])
                  ], 8, _hoisted_7)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_ErrorMessage, { name: "source" })
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("button", {
        class: "btn btn-secondary btn-sm",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideAllForm && _ctx.hideAllForm(...args)))
      }, " Sembunyikan Semua Formulir "),
      _createVNode(_component_Field, {
        modelValue: _ctx.form_count,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form_count) = $event)),
        type: "number",
        name: "form_count",
        min: "1",
        max: "50",
        class: "form-control form-control-sm",
        style: {"width":"60px"}
      }, null, 8, ["modelValue"]),
      _createElementVNode("button", {
        class: "btn btn-primary btn-sm",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addNewForm && _ctx.addNewForm(...args)))
      }, " + Formulir ")
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.news_data, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "card mb-5 mb-xl-10"
      }, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", {
            class: "card-title w-100",
            role: "button",
            "data-bs-toggle": "collapse",
            "data-bs-target": '#' + 'form_' + index.toString(),
            "aria-expanded": "true",
            "aria-controls": 'form_' + index.toString()
          }, [
            _createElementVNode("h3", _hoisted_17, "Formulir Berita #" + _toDisplayString(index + 1), 1)
          ], 8, _hoisted_16),
          (_ctx.news_data.length > 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-danger btn-sm ms-auto",
                style: {"position":"absolute","right":"20px","top":"20px","z-index":"999"},
                onClick: ($event: any) => (_ctx.deleteForm(index))
              }, " Hapus ", 8, _hoisted_18))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          id: 'form_' + index.toString(),
          class: "collapse show"
        }, [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_MediaTVFormInput, {
              data: item,
              index: index,
              onResetForm: _ctx.resetSelectedForm
            }, null, 8, ["data", "index", "onResetForm"])
          ])
        ], 8, _hoisted_19)
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("button", {
        class: "btn btn-secondary btn-sm",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.hideAllForm && _ctx.hideAllForm(...args)))
      }, " Sembunyikan Semua Formulir "),
      _createVNode(_component_Field, {
        modelValue: _ctx.form_count,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form_count) = $event)),
        type: "number",
        name: "form_count",
        min: "1",
        max: "50",
        class: "form-control form-control-sm",
        style: {"width":"60px"}
      }, null, 8, ["modelValue"]),
      _createElementVNode("button", {
        class: "btn btn-primary btn-sm",
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addNewForm && _ctx.addNewForm(...args)))
      }, " + Formulir "),
      _createElementVNode("button", {
        ref: "save_button",
        class: "btn btn-success btn-sm btn-block",
        disabled: _ctx.is_disable_save,
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.saveAllData && _ctx.saveAllData(...args)))
      }, _hoisted_25, 8, _hoisted_22)
    ])
  ]))
}